export enum SessionStorageKeys {
  cameFrom = 'cameFrom',
  tempDeliveryData = 'tempDeliveryData',
  language = 'language',
  userData = 'userData',
  isReorderingDisabled = 'isReorderingDisabled',
}
